import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Alert } from '@material-ui/lab';
import { SummaryLabelledInfo } from '../labelled-info';
import { CostStatementReceiveLabel } from '../../../cost-statement';
import { BuyProcessState } from '../../../../buy-process-form-types';
import { BuyProcessUtils } from '../../../../index';
import { Amount } from '../../../../../amount/amount';

interface SummaryCostStatementProps {
  costStatement: BuyProcessState['costStatement'];
}

export const SummaryCostStatement = ({
  costStatement,
}: SummaryCostStatementProps) => {
  const { receiveOption, receiverEmails } = costStatement;
  const extraServicesCost = BuyProcessUtils.getExtraServicesCost();

  const renderMoney = (amount: number) => (
    <strong>
      <Amount locale="sv-SE" amount={amount} />
    </strong>
  );

  const renderBeneficialCost = () =>
    extraServicesCost?.totalPayment.beneficialCost && (
      <>
        <span>
          Arvode samt Bolagsverkets avgift för registrering av verklig huvudman:{' '}
          {renderMoney(extraServicesCost.totalPayment.beneficialCost)}
        </span>
        <br />
      </>
    );

  const renderNameReviewCost = () =>
    extraServicesCost?.totalPayment.nameReviewCost && (
      <>
        <span>
          Arvode för namngranskning:{' '}
          {renderMoney(extraServicesCost.totalPayment.nameReviewCost)}
        </span>{' '}
        <br />
      </>
    );

  const renderTaxHelpCost = () =>
    extraServicesCost?.totalPayment.taxHelpCost && (
      <>
        <span>
          Arvode för ansökan om f-skatt, moms och arbetsgivare:{' '}
          {renderMoney(extraServicesCost.totalPayment.taxHelpCost)}
        </span>
        <br />
      </>
    );

  const renderEmails = () => {
    if (receiveOption === 'mail') return null;

    return (
      <SummaryLabelledInfo label="E-postadresser för underskrifter">
        {receiverEmails.map((email) => (
          <Typography variant="body2">{email}</Typography>
        ))}
      </SummaryLabelledInfo>
    );
  };

  if (!extraServicesCost) {
    return null;
  }

  return (
    <React.Fragment>
      <Typography gutterBottom variant="subtitle2">
        Kostnader (ex. moms):
      </Typography>

      <Alert
        style={{ marginBottom: '16px' }}
        severity="info"
        variant="standard"
      >
        <Typography style={{ fontSize: '14px' }}>
          Bolagsverkets avgifter:{' '}
          {renderMoney(extraServicesCost.totalPayment.registrationCost)} <br />
          Arvode och administrationskostnad för lagerbolag:{' '}
          {renderMoney(extraServicesCost.totalPayment.administrationCost)}{' '}
          <br />
          {renderBeneficialCost()}
          {renderNameReviewCost()}
          {renderTaxHelpCost()}
          <strong>
            Totalt att betala:{' '}
            {renderMoney(extraServicesCost.totalPayment.totalPayment)} (varav
            moms: {renderMoney(extraServicesCost.totalPayment.vat)})
          </strong>
        </Typography>
      </Alert>

      <SummaryLabelledInfo label="Hur vill du ta emot och signera handlingarna?">
        {CostStatementReceiveLabel[receiveOption]}
      </SummaryLabelledInfo>

      {renderEmails()}
    </React.Fragment>
  );
};
